declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    youtube: {
      /**
       * Add an image
       */

      insertYoutube: (url?: string, className?: string) => ReturnType
    }
  }
}

import { Node, PasteRule, markPasteRule, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import YoutubeEmbed from './YoutubeEmbed.js'

export const Youtube = Node.create({
  name: 'youtube',

  group: 'block',
  content: 'inline*',
  draggable: true,

  // content: 'inline*',
  parseHTML() {
    return [
      {
        tag: 'div[data-type="youtube"]',
      },
    ]
  },
  addAttributes() {
    return {
      url: { default: null },
      class: { default: null },
      src: {
        default: null,
      },
      width: {
        default: '560',
      },
      height: {
        default: '315',
      },
      frameborder: {
        default: '0',
      },
      allowfullscreen: {
        default: true,
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => {
        return this.editor
          .chain()
          .insertContentAt(this.editor.state.selection.head, {
            type: this.type.name,
          })
          .focus()
          .run()
      },
    }
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "youtube",
        class: `react-renderer node-youtube  ${HTMLAttributes.class ?? ""}`,
      }), [
        'div',
        mergeAttributes(
          { class: 'socialMediaContainer' },
        ),
        ['div', mergeAttributes({ class: 'rsme-embed rsme-youtube-embed', style: 'overflow: hidden; border-radius: 0px;' }),
          ['div', { class: 'youtube-iframe' },
            ['iframe', mergeAttributes(HTMLAttributes, { src: convertYoutubeUrlToEmbed(HTMLAttributes.url) },)],
          ]
        ]
      ]
    ]
  },
  addNodeView() {
    return ReactNodeViewRenderer(YoutubeEmbed)
  },

  addCommands() {
    return {
      insertYoutube:
        (url, className) =>
          ({ commands, state }) => {
            let embedUrl = ''

            if (url) {
              embedUrl = convertYoutubeUrlToEmbed(url)
            }

            return commands.insertContent({
              type: 'youtube',
              attrs: {
                url,
                class: className,
                src: embedUrl,
              },
            })
          },
    }
  },
})





function convertYoutubeUrlToEmbed(url: string): string | undefined {
  if (!url) return undefined;
  try {
    // Extract video ID from various YouTube URL formats
    const urlObj = new URL(url)
    let videoId = ''

    if (urlObj.hostname === 'youtu.be') {
      // Handle youtu.be format
      videoId = urlObj.pathname.slice(1)
    } else {
      // Handle youtube.com formats
      const searchParams = new URLSearchParams(urlObj.search)
      videoId = searchParams.get('v') || ''

      if (!videoId) {
        // Try extracting from pathname for embed URLs
        const matches = urlObj.pathname.match(/\/embed\/([^/?]+)/)
        if (matches) {
          videoId = matches[1]
        }
      }
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : undefined;
  } catch {
    return undefined;
  }
}
function isValidHttpUrl(string: string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
